import styles from './VisualSearchIllustration.module.css';

import {
  VISUAL_SEARCH_LISTING_IMAGE,
  VISUAL_SEARCH_PHOTO_IMAGE,
} from '@/modules/visualSearch/constants';

export function VisualSearchIllustration() {
  return (
    <div className={styles.stage} aria-hidden="true">
      <div className={styles.composition}>
        <div className={styles.phone}>
          <img
            className={styles.photo}
            src={VISUAL_SEARCH_PHOTO_IMAGE}
            alt=""
          />
          <div className={styles.scan}>
            <span className={styles.lit} />
            <span className={styles.cornerTopLeft} />
            <span className={styles.cornerTopRight} />
            <span className={styles.cornerBottomLeft} />
            <span className={styles.cornerBottomRight} />
          </div>
        </div>
        <div className={styles.matchCard}>
          <div className={styles.listingImage}>
            <img src={VISUAL_SEARCH_LISTING_IMAGE} alt="" />
          </div>
          <span className={styles.listingTitle}>Striped t-shirt</span>
        </div>
      </div>
    </div>
  );
}
